"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_RECOMMENDATIONS = exports.RECOMMENDATION_REASONS = void 0;
exports.recommendCharts = recommendCharts;
const charts_1 = require("./charts");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ C59 · "This would read better as a …"                                     │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **A PICKER WITH TWENTY-FIVE ENTRIES IS A PICKER NOBODY OPENS TWICE.** The mockup's `repRecos`
 * is the half that makes the catalogue usable: it looks at the shape of the RESULT — how many
 * groups, how concentrated, whether the dimension has an order — and offers at most three
 * alternatives, each with the reason it is suggesting them. Without it the twenty-five are a menu
 * of names, and people keep using the bar because it is the one they can predict.
 *
 * ⚠️ **Each suggestion carries WHY.** *"Seven categories — the names fit horizontally"* is something
 * a reader can agree or disagree with; a bare list of three chart names is a lucky dip.
 *
 * ⚠️ **Never the chart already on screen, and never one the report cannot carry.** Both are
 * embarrassing in the same way: they make the suggestion look automatic rather than considered.
 */
/** Why a shape is being suggested. The client words it; this says which sentence. */
exports.RECOMMENDATION_REASONS = [
    /** One group — a single figure reads better as a figure. */
    'single',
    /** The dimension has an order, so a trend is meaningful. */
    'ordered',
    /** Hours by day — a calendar shows the rhythm. */
    'rhythm',
    /** Many categories — horizontal names fit, and a treemap shows the proportions. */
    'many',
    /** Few categories — a clean proportion. */
    'few',
    /** One category dominates. */
    'dominant',
    /** The measure has a companion worth putting beside it. */
    'companion',
    /** Enough months for a matrix. */
    'months',
];
/** At most this many, because a fourth suggestion is noise rather than help. */
exports.MAX_RECOMMENDATIONS = 3;
function recommendCharts(report) {
    const out = [];
    const add = (chart, reason) => {
        if (out.length >= exports.MAX_RECOMMENDATIONS)
            return;
        /* ⚠️ Never what is already drawn, never a duplicate, never one the report cannot carry. */
        if (chart === report.chart)
            return;
        if (out.some((one) => one.chart === chart))
            return;
        if ((0, charts_1.chartRefusal)(chart, report) !== null)
            return;
        out.push({ chart, reason });
    };
    if (report.groupCount === 1) {
        add('metric', 'single');
        add('gauge', 'single');
    }
    /**
     * ⚠️ **A trend needs an ORDERED dimension, and only one of ours is.** Periods run in sequence;
     * projects and people do not, and a line joining "Haystack" to "Rossmann" draws a slope that
     * means nothing at all — which is the most confidently wrong chart in the whole catalogue.
     */
    if (report.dimension === 'occurrence') {
        add('line', 'ordered');
        add('area', 'ordered');
    }
    if (report.hasDays && report.metric === 'hours')
        add('calendar', 'rhythm');
    if (report.groupCount >= 7) {
        add('hbar', 'many');
        add('treemap', 'many');
    }
    if (report.groupCount >= 3 && report.groupCount <= 6) {
        add('donut', 'few');
        add('breakdown', 'few');
    }
    if (charts_1.CHART_NEEDS.vgroup === 'companion' && (0, charts_1.chartRefusal)('vgroup', report) === null) {
        add('vgroup', 'companion');
        add('barline', 'companion');
    }
    if (report.topShare > 0.6)
        add('donut', 'dominant');
    if (report.hasMatrix && report.monthCount >= 3)
        add('heatmap', 'months');
    return out;
}
//# sourceMappingURL=recommend.js.map